import { MapPin } from "lucide-react";
import { formatPrettyAddress } from "../../../../utils/helpers";

const SeeOnMap = ({ location, className = "" }) => {
  if (!location) return null;

  const address = formatPrettyAddress(location);

  const mapUrl =
    location?.coordinates?.length === 2
      ? `https://www.google.com/maps?q=${location.coordinates[1]},${location.coordinates[0]}`
      : `https://www.google.com/maps?q=${encodeURIComponent(address)}`;

  return (
    <div
      className={`flex flex-col md:w-fit md:flex-row  justify-between gap-1 md:gap-4 text-gray-600 text-xs sm:text-sm ${className}`}
    >
      {/* Address */}
      <span className="truncate">{address}</span>

      {/* "See on Map" Link */}
      <a
        href={mapUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-blue-600 hover:text-blue-700 transition-colors duration-200 font-medium cursor-pointer text-xs md:text-sm  lg:text-base whitespace-nowrap"
      >
        <MapPin className="w-4 h-4" />
        See on Map
      </a>
    </div>
  );
};

export default SeeOnMap;
